import styled from 'styled-components';
import colors from 'constants/colors'

export const DatePickerContainer = styled.div`
  height: 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-sizing: border-box;
  position: relative;

  .MuiTextField-root {
    ${({ additionalstyle }) => additionalstyle};
  }

  div .MuiOutlinedInput-root {
    ${(props) => (props.disabled? `border: 1px solid ${colors.silver};`: null)};
    border-radius: 0;
    padding: 0;
    :focus-visible {
      outline: none;
    }
    fieldset {
      border: none;
    }
  }

  input {
    box-sizing: border-box;
    height: 40px;
    font-size: 14px;
    font-weight: 600;
    font-family: 'Titillium Web', sans-serif; 
    color: ${colors.white};
    padding: 9px 10px;

    @media only screen and (min-width: 767px) and (max-width: 1200px) {
      height: 46px;
      font-size: 15px;
    }

    @media only screen and (max-width: 767px) {
      height: 44px;
      font-size: 13px;
    }
  }

  .Mui-disabled {
    background-color: ${(props) => (props.disabled? colors.dimGrey: colors.black2)};
    -webkit-text-fill-color: ${colors.silver} !important;
  }

  button {
    position: absolute;
    right: 16px;
    
    svg {
      ${(props) => (props.disabled? `filter: contrast(0%) brightness(135.94%);`: null)};
    }
  }

  button:focus {
    outline: none;
  }
`;